import { FormValidators } from '@servicetitan/form/dist/form-validators';

export const requiredWithCustomText = (error: string) => (value: any) =>
    FormValidators.required(value) && error;

export const maxLengthValidation = (maxLength: number) => (value: string) =>
    value.length > maxLength && `# of characters cannot be greater than ${maxLength}.`;

export const phoneValidation =
    (error: string, emptyValue = '') =>
    (value: string) =>
        value && value !== emptyValue && !/\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/i.test(value) && error;
